import { GROUPS } from 'constants/permissions';
import { useAuth } from 'hooks/useAuth';
import Main from 'layout/main';
import Viewer from 'pages/Viewer';
import {
  DailyBulletin,
  GroupPermission,
  Prediction,
  // desabilitar em prod FollowUpPanel
  // FollowUpPanel,
  StockPosition,
} from 'pages';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { IRoute } from './types';
import {
  AnomalyV2Redirect,
  ChecklistV2Redirect,
  FollowUpReportV2Redirect,
  FollowUpServicesV2Redirect,
  InspectionChecklistReportV2Redirect,
  PlanningV2Redirect,
  RegisterEquipmentV2Redirect,
} from './v2Redirects';

const routes: Array<IRoute> = [
  {
    // path: '/planejamento',
    path: '/',
    exact: true,
    name: 'planning',
    component: PlanningV2Redirect,
    meta: {
      title: 'Planejamento',
      // ocultar a rota em prod
      hidden: false,
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/visualizador-imagem/:path',
    name: 'viewer',
    component: Viewer,
    meta: {
      title: 'Visualizador de Imagens',
      hidden: true,
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/cadastro-equipamento',
    name: 'register-equipment',
    component: RegisterEquipmentV2Redirect,
    meta: {
      title: 'Cadastro de Equipamento',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/boletim-diario',
    name: 'daily-bulletin',
    component: DailyBulletin,
    meta: {
      title: 'Boletim Diário',
      // ocultar a rota em prod
      hidden: false,
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  // ocultar o relatorio id em prod
  // {
  //   path: '/relatorio/:id',
  //   name: 'inspection-checklist-report',
  //   component: InspectionChecklistReport,
  //   meta: {
  //     title: 'Boletim Diário',
  //     hidden: true,
  //     permissions: [
  //       GROUPS.ADMINISTRATOR,
  //       GROUPS.PLANNING,
  //       GROUPS.ENGINEERING,
  //       GROUPS.TECHNICIAN,
  //       GROUPS.GENERAL,
  //     ],
  //   },
  // },
  {
    // path: '/',
    path: '/checklist',
    name: 'inspection-checklist',
    component: ChecklistV2Redirect,
    meta: {
      title: 'Inspeções ',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
    children: [
      {
        // path: '/',
        path: '/checklist/inspecao',
        name: 'inspection-checklist',
        component: ChecklistV2Redirect,
        exact: true,
        meta: {
          title: 'Checklist de Inspeção',
          permissions: [
            GROUPS.ADMINISTRATOR,
            GROUPS.PLANNING,
            GROUPS.ENGINEERING,
            GROUPS.TECHNICIAN,
            GROUPS.GENERAL,
          ],
        },
      },
      {
        path: '/checklist/cadastrar',
        name: 'register-checklist',
        component: ChecklistV2Redirect,
        exact: true,
        meta: {
          title: 'Cadastrar Checklist de Inspeção',
          permissions: [
            GROUPS.ADMINISTRATOR,
            GROUPS.PLANNING,
            GROUPS.ENGINEERING,
            GROUPS.TECHNICIAN,
            GROUPS.GENERAL,
          ],
        },
      },
    ],
  },
  {
    // path: '/relatorio/:id',
    path: '/checklist/relatorio/:id',
    name: 'inspection-checklist-report',
    component: InspectionChecklistReportV2Redirect,
    meta: {
      title: 'Checklist de Inspeção',
      hidden: true,
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/predicao',
    name: 'prediction',
    component: Prediction,
    meta: {
      title: 'Predição',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/acompanhamento-servico',
    name: 'service-monitoring',
    exact: true,
    component: FollowUpServicesV2Redirect,
    meta: {
      title: 'Acompanhamento de Serviço',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/acompanhamento-servico/relatorio/:id',
    name: 'service-monitoring-report',
    component: FollowUpReportV2Redirect,
    meta: {
      title: 'Acompanhamento de Serviço',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
      hidden: true,
    },
  },
  {
    path: '/posicao-estoque',
    name: 'stock-position',
    component: StockPosition,
    meta: {
      title: 'Posição de Estoque',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/anomalias',
    name: 'anomaly',
    component: AnomalyV2Redirect,
    meta: {
      title: 'Anomalias',
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  {
    path: '/permissionamento-grupo',
    name: 'group-permission',
    component: GroupPermission,
    meta: {
      title: 'Permissionamento de Grupo',
      // permissions: [GROUPS.ADMINISTRATOR, GROUPS.PLANNING],
      permissions: [
        GROUPS.ADMINISTRATOR,
        GROUPS.PLANNING,
        GROUPS.ENGINEERING,
        GROUPS.TECHNICIAN,
        GROUPS.GENERAL,
      ],
    },
  },
  // ocultar em prod o painel de acompanhamento
  // {
  //   path: '/painel-acompanhamento',
  //   name: 'follow-up-panel',
  //   component: FollowUpPanel,
  //   meta: {
  //     title: 'Painel de Acompanhamento',
  //     permissions: [
  //       GROUPS.ADMINISTRATOR,
  //       GROUPS.PLANNING,
  //       GROUPS.ENGINEERING,
  //       GROUPS.TECHNICIAN,
  //       GROUPS.GENERAL,
  //     ],
  //   },
  // },
];

const Routes: React.FC = () => {
  const { checkPermissions } = useAuth();

  const authorizedRoutes = React.useMemo(() => {
    return routes.filter(router => {
      if (router.meta.permissions) {
        return checkPermissions(router.meta?.permissions);
      }
      return false;
    });
  }, [checkPermissions]);

  return (
    <BrowserRouter>
      <Switch>
        <Main routes={authorizedRoutes}>
          {authorizedRoutes.map((route, idx) => {
            return (
              route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                />
              )
            );
          })}
        </Main>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
